import React from "react";
import { useDispatch } from "react-redux";

import { AlertMessageBanner } from "../../store/bannerMessage/types";
import { dismissBreachAlertMessage } from "../../store/service";
import { msgLevel } from "../Dashboard/BannerMessage";
import * as BannerMessageActions from "../../store/bannerMessage/actions";

interface IBreachBannerMessage {
    alert: AlertMessageBanner;
    index: number;
}

const BreachBannerMessage: React.FunctionComponent<IBreachBannerMessage> = ({ alert, index }) => {
    const dispatch = useDispatch();
    const requestBannerMessage = (needToRefresh?: boolean) => dispatch(BannerMessageActions.actionCreators.getBannerAlertMessage(needToRefresh));
    const resetBannerMessage = () => dispatch(BannerMessageActions.actionCreators.resetBannerAlertMessage());
    const messageArr = alert.message ? alert.message.split(" - ") : [];

    const onBreachMessageClose = () => {
        if (alert.alertid) {
            dismissBreachAlertMessage({ alertId: alert.alertid }).then((res) => {
                if (res.isSuccess) {
                    resetBannerMessage();
                    requestBannerMessage(true);
                }
            });
        }
    };
    const handleKeyDown = (e: { keyCode: number }) => {
        if (e.keyCode === 13) {
            onBreachMessageClose();
        }
    };

    return (
        <div
            key={"banner-alert-message-" + index}
            style={{ display: "block" }}
            role="banner"
            className={
                alert.messageLevel === msgLevel.CRITICAL
                    ? "m-sys-msg alert"
                    : alert.messageLevel === msgLevel.IMPORTANT
                    ? "m-sys-msg info"
                    : alert.messageLevel === msgLevel.INFORMATION
                    ? "m-sys-msg information"
                    : "m-sys-msg default"
            }
        >
            <div className="l-page-container">
                <div className="sys-msg-content" style={{ padding: "0.5rem" }}>
                    <div className="hide-sm-up hide-mobile show-md-up">
                        <div className="flex">
                            <div className="flex">
                                <div className="flex fw-600" style={{ flexShrink: 0, paddingTop: "0.25rem" }}>
                                    {messageArr[0]}
                                </div>
                                <span style={{ padding: "0.25rem 0.5rem" }}>-</span>
                                <p>{messageArr[1]}</p>
                            </div>
                            <span role="button" tabIndex={0} onClick={onBreachMessageClose} onKeyDown={handleKeyDown}>
                                <em className="las la-times-circle inline-icon cursor-pointer"></em>
                            </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 hide-md-up flex-shrink-0">
                            <div className="flex justify-space-bt align-items-center">
                                <span className="fw-600">{messageArr[0]}</span>
                                <span role="button" tabIndex={0} onClick={onBreachMessageClose} onKeyDown={handleKeyDown}>
                                    <em className="las la-times-circle inline-icon cursor-pointer"></em>
                                </span>
                            </div>
                        </div>
                        <div className="col-xs-12 hide-md-up">
                            <p>{messageArr[1]}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BreachBannerMessage;
